import React, { DispatchWithoutAction } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { BaseButton as Button } from '../../../../../BaseComponents';
import { Money } from '../../../../../Money';
import { useTheme } from '../../../../../theme';
import { UpsaleService } from '../../types';
import { SafeHtml } from '@shared/ui';

interface AiPurchasePredictionCardProps {
	className?: string;
	title?: string;
	service: UpsaleService;
	onChange?: DispatchWithoutAction;
	footer?: React.ReactNode;
}

const UpsaleItem: React.FC<AiPurchasePredictionCardProps> = ({ title, service, onChange, footer, className }) => {
	const {
		Upsale: { UpsaleItem: theme }
	} = useTheme('Features');

	const { t } = useTranslation('AIPurchasePredictionService');

	return (
		<div className={cn(theme.root, className)}>
			{title && <div className={theme.header}>{title}</div>}

			<div className={theme.card}>
				{React.isValidElement<{ className?: string }>(service.header) &&
					React.cloneElement(service.header, {
						className: theme.serviceHeader
					})}

				<div className={theme.content}>
					<div className={theme.description}>
						<div className={theme.label}>{service.name}</div>

						{typeof service.description === 'string' ? (
							<SafeHtml html={service.description} />
						) : (
							service.description
						)}

						<span>{t('All flights')}</span>
					</div>

					<div className={theme.cost}>
						<Money money={service.price} moneyClassName={theme.price} />

						{onChange && (
							<Button variant={'optionEdit'} onClick={onChange}>
								{t('Change')}
							</Button>
						)}
					</div>
				</div>
			</div>
			{footer}
		</div>
	);
};

export default UpsaleItem;
